import request from '@/utils/axios/request'
const isDevelopment = process.env.NODE_ENV === 'development'
const HOST = window.location.origin
const PREFIX = isDevelopment ? '' : `${HOST}/api/uc`


interface PhoneCodeParams {
    mobile: string
    usage: string
}

interface EmailCodeParams {
    email: string
    usage: string
    redirectURL?: string
}

interface VerifyMobileCodeParams {
    mobile: string
    verifyCode: string
    usage: string
}
interface VerifyEmailCodeParams {
    email: string
    verifyCode: string
    usage: string
}

interface VerifyEmailParams {
    emailCode: string
}
interface RegisterParams {
    mobile: string
    verifyCode: string
    password: string
}
interface SetPasswordParams {
    account: string
    userId: string
    password: string 
    type: string
    setLater: number
    mobile?: string
    // password?: string
}
interface ResetPasswordParams {
    account: string
    password: string
    verifyCode: string
    type: string
    setLater: number
    mobile?: string
    oldPassword?: string
    newPassword?: string
}

interface UpdateUsernameParams {
    userId: string
    username: string
}

interface CreatTeamParams {
    code?: string
    name: string
    domain?: string
    icon?: string
    parentId: number
    platform: number
    userId: string
}
interface EnterTeamParams {
    entId: string
    userId: string
}

const commonService = {
    verifyAccount(account: string, usage: string) {
        return request.get(`/v1/account/${account}/verify?usage=${usage}&mode=''`)
    },
    sendPhoneCode(params: PhoneCodeParams) {
        return request.post('/v1/sms/code', params)
    },
    sendEmailCode(params: EmailCodeParams) {
        return request.post(`${PREFIX}/email/send`, params)
    },
    verifyMobileCode(params: VerifyMobileCodeParams) {
        return request.post('/v1/sms/verification', params)
    },
    verifyEmailCode(params: VerifyEmailCodeParams) {
        return request.post('/v1/email/verification', params)
    },
    verifyEmail(params: VerifyEmailParams) {
        // 对 emailCode 参数进行编码
        const encodedParams = {
            ...params,
            emailCode: encodeURIComponent(params.emailCode)
        }
        return request.get(`${PREFIX}/email/verify`, encodedParams)
    },
    register(params: RegisterParams) {
        return request.post('/v1/user/register', params)
    },
    resetPassword(params: ResetPasswordParams) {
        return request.post('/user/password/forget', params)
    },
    getPasswordRules() {
        return request.get('v1/password/verify/config')
    },
    setPassword(params: SetPasswordParams) {
        return request.post('/user/password/initial', params)
    },
    updateUserName(params: UpdateUsernameParams) {
        return request.post(`/v1/user/${params.userId}`, { trueName: params.username })
    },
    verifyCaptcha(captchaCode: string) {
        return request.get(`/v1/picture/validateImgCode?validateCode=${captchaCode}`)
    },
    getTeamList(userId: string) {
        return request.get(`/v1/enterprise/user/${userId}`)
    },
    creatTeam(params: CreatTeamParams) {
        return request.post('/v1/enterprise/create', params)
    },
    enterTeam(params: EnterTeamParams) {
        return request.post(`/v1/enterprise/${params.entId}/user/enter`, {})
    }
}
export default commonService
